var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFourthCardFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2401_8924)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 84.0168,
    height: 84.0168,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 10.5,
    width: 83.0168,
    height: 83.0168,
    rx: 11.5,
    stroke: "#D7DEFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.505 31.4054L52.0074 29.9531L66.5099 31.4054L77.7375 45.6816L52.0074 74.0618L26.2773 45.6816L37.505 31.4054Z",
    fill: "#FDB300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6992 45.6816L52.0073 74.062L26.2773 45.6816H36.6992ZM67.3158 45.6816L52.0077 74.062L77.7377 45.6816",
    fill: "#EA6C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6992 45.6816H67.3154L52.0073 74.062",
    fill: "#FDAD00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0073 29.9531L37.5049 31.4051L36.6992 45.6815L52.0073 29.9531ZM52.0076 29.9531L66.51 31.4051L67.3157 45.6815",
    fill: "#FDD231"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7377 45.6806L66.5101 31.4043L67.3158 45.6806H77.7377ZM26.2773 45.6806L37.5049 31.4043L36.6992 45.6806",
    fill: "#FDAD00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0073 29.9531L36.6992 45.6815H67.3154",
    fill: "#FEEEB7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2401_8924",
    x: 0,
    y: 0,
    width: 108.018,
    height: 108.018,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2401_8924"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2401_8924",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourthCardFirst);
export default __webpack_public_path__ + "static/media/fourth-card-first.37e990b82a7e6e9bd51d24a6ba028492.svg";
export { ForwardRef as ReactComponent };